module.exports = __webpack_public_path__ + "assets/29bdc51a2aead513c12f22118e1917aa.jpg";